import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDonut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      d="M7.159 9.61a10.78 10.78 0 0 0 10.992 15.12l-.512-4.759a5.992 5.992 0 0 1-6.111-8.407z"
    />
    <path
      fill="#98B9FA"
      d="M18.044 24.742a10.78 10.78 0 0 0 7.92-16.714l-3.98 2.658a5.993 5.993 0 0 1-4.404 9.293z"
    />
    <path
      fill="#C8D9FC"
      d="M27.092 10.225A10.778 10.778 0 0 0 10.71 5.258l2.793 3.886a5.993 5.993 0 0 1 9.11 2.762l4.48-1.681Z"
    />
    <path
      fill="#1F5ACE"
      d="M11.15 4.958a10.8 10.8 0 0 0-4.167 5.077L11.43 11.8a6 6 0 0 1 2.317-2.823l-2.599-4.019Z"
    />
  </svg>
);
export default SvgDonut;
